<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-img
          src="../../../assets/figmaIcons/white/standchecklist.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">
        Checklist - {{ $t('Rotina de Inspeção') }}
      </span>

      <v-spacer></v-spacer>
    </div>

    <div class="mt-4">
      <v-tabs color="secondary" v-model="tab">
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab active-class="activated-tab" class="rounded-lg rounded-b-0"
          ><v-icon class="mr-1">mdi-checkbox-marked-outline</v-icon>

          <span>Checklists</span>
        </v-tab>

        <v-tab
          v-if="institution.userType != 5"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
          ><v-icon class="mr-1">mdi-form-select</v-icon
          ><span>Templates</span></v-tab
        >
        <v-tab
          v-if="institution.userType != 5"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          <v-icon class="mr-1">mdi-format-list-checkbox</v-icon>
          <span>Itens</span></v-tab
        >
        <v-tab
          v-if="institution.userType != 5"
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
        >
          <v-icon class="mr-1">mdi-file-tree-outline</v-icon>
          <span>Classes</span></v-tab
        >
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <Checklists />
      </v-tab-item>

      <v-tab-item>
        <Templates />
      </v-tab-item>

      <v-tab-item>
        <Itens />
      </v-tab-item>

      <v-tab-item>
        <Class />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import Itens from './components/itens/itens.vue'
import Templates from './components/templates/templates.vue'
import Checklists from './components/checklists/checklists.vue'
import Class from './components/class/Class.vue'

export default {
  name: 'InspectionRoutineChecklistPage',

  components: {
    Itens,
    Templates,
    Checklists,
    Class,
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
  },

  data() {
    return {
      institution: {},
      user: {},
      tab: null,
    }
  },
}
</script>

<style></style>
